import { render } from "./AppSnackbar.vue?vue&type=template&id=0628ebdc&scoped=true&ts=true"
import script from "./AppSnackbar.vue?vue&type=script&lang=ts"
export * from "./AppSnackbar.vue?vue&type=script&lang=ts"

import "./AppSnackbar.vue?vue&type=style&index=0&id=0628ebdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0628ebdc"]])

export default __exports__